import React from 'react';
import { Typography } from '@mui/material';
import TickWithBorderIcon from 'components/Icons/TickWithBorderIcon';
import WavetrakLink from 'components/WavetrakLink';

import styles from './CamFeedbackFormSuccessWrapper.module.scss';

const CamFeedbackFormSuccess = () => (
  <div className={styles.successWrapper} data-testid="cam-feedback-form-success">
    <div className={styles.successBody}>
      <TickWithBorderIcon className={styles.tickIcon} />
      <Typography className={styles.title} variant="headline">
        Thanks for your feedback.
      </Typography>
      <Typography className={styles.subTitle} variant="body">
        You’re helping our camera team improve the cams.
      </Typography>
    </div>
    <Typography className={styles.hostCamMessage} variant="footnote">
      {' '}
      Want to host a cam?{' '}
      <WavetrakLink href="https://go.surfline.com/cam-host" target="_blank" isExternal>
        Find out how
      </WavetrakLink>
    </Typography>
  </div>
);

export default CamFeedbackFormSuccess;
